import { useObservable } from './useObservable';
import { Subject, timer, throwError, of, map, distinctUntilChanged, switchMap, tap, takeWhile, retryWhen, delay, catchError } from 'rxjs';
import { differenceInSeconds } from 'date-fns';
import { NowTime } from '@golden/gdk-base';
const DEFAULT_EXCHANGE_RATE = '1.0000';
export default function useExchangeRate(gdk) {
    const flow$ = new Subject();
    const refresh = () => {
        exchangeRate.value = { buy: DEFAULT_EXCHANGE_RATE, sell: DEFAULT_EXCHANGE_RATE, min: '00', sec: '00', loading: true, error: false };
        flow$.next();
    };
    const exchangeRate = useObservable(flow$.pipe(switchMap(() => gdk.exchangeRate.getExchangeRate().pipe(switchMap(({ buy, sell, expired_at }) => {
        if (differenceInSeconds(expired_at, NowTime.get()) <= 0) {
            return throwError(() => new Error('expireTime is past'));
        }
        return timer(0, 1000).pipe(map(() => ({
            second: differenceInSeconds(expired_at, NowTime.get()),
            buy,
            sell
        })), distinctUntilChanged(), tap(({ second }) => {
            if (second <= 0)
                flow$.next();
        }), takeWhile(({ second }) => second >= 0));
    }), retryWhen((errorObs) => {
        let retries = 0;
        return errorObs.pipe(delay(1000), map((error) => {
            if (retries++ === 5) {
                throw error;
            }
            return error;
        }));
    }), map(({ second, buy, sell }) => {
        const min = (Math.floor(second / 60)).toString().padStart(2, '0');
        const sec = (second % 60).toString().padStart(2, '0');
        return {
            buy: Number(buy) === 0 ? DEFAULT_EXCHANGE_RATE : buy, // 分母不可以為 0
            sell: Number(sell) === 0 ? DEFAULT_EXCHANGE_RATE : sell, // 分母不可以為 0
            min,
            sec,
            loading: false,
            error: false
        };
    }), catchError(() => of({ buy: DEFAULT_EXCHANGE_RATE, sell: DEFAULT_EXCHANGE_RATE, min: '00', sec: '00', loading: false, error: true }))))), { buy: DEFAULT_EXCHANGE_RATE, sell: DEFAULT_EXCHANGE_RATE, min: '00', sec: '00', loading: true, error: false });
    refresh();
    return { refresh, exchangeRate };
}
//# sourceMappingURL=useExchangeRate.js.map